/**
 *
 * EmptyStateAnonymity
 *
 */

import React from "react"
import { Empty } from "antd"
import empty_meditions from "images/empty/anonymity.svg"
import { LOCAL_ANONYMITY, LOCAL_ANONYMITY_LEADERS } from "../../utils/storage"
import { loadTexts, sanitize } from "../../utils/i18n"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

const EmptyStateAnonymity = ({ count, image, title, description }) => {
  return (
    <div>
      <Empty
        style={{ color: "#828282" }}
        image={image}
        description={
          <span
            style={{ margin: "24px auto 0", maxWidth: 480, display: "block" }}>
            <span style={{ fontWeight: 600, fontSize: 16, display: "block" }}>
              {title}
            </span>
            {description && (
              <span style={{ marginTop: 10, display: "block" }}>
                {description}
              </span>
            )}
          </span>
        }
      />
    </div>
  )
}

EmptyStateAnonymity.defaultProps = {
  count: 1,
  image: empty_meditions,
  title: "¡Tu división no cuenta con resultados!",
  description:
    "Parece que la división de la que has sido asignado como embajador no cuenta con resultados debido a que no se ha superado el mínimo de anonimato para las respuestas.",
}

export default EmptyStateAnonymity
